module.exports = {"label":{"title":"Verfügbarer Nameserver"},"header":{"name":"Name","location":"Standort"}}